import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default  {
  ...cloneDeep(baseDefaults), 
  pillBackgroundColor: 'var(--color-greyLight)',
  pillTextColor: 'var(--color-secondary)',
  alignment: 'left',
  items: [
    {
      title: 'Label Title',
      src: 'https://res.cloudinary.com/ditbeukyz/image/upload/v1605878200/Resources/placeholder.svg?cratio=16x9',
    }
  ]
}

